'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'boxes-packing';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e4c7';
var svgPathData = 'M432 48l48 0c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16l-81.1 0c-2.5 17.7-9.2 34-18.9 48L480 512c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L224 0c-35.3 0-64 28.7-64 64l0 80 48 0 0-80c0-8.8 7.2-16 16-16l48 0 0 72c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-72zm-48 0l0 48-64 0 0-48 64 0zM304 448c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16l0-112 224 0 0 112zM32 323.8L32 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-124.2c9.8-8.8 16-21.6 16-35.8l0-48c0-26.5-21.5-48-48-48L64 192c-26.5 0-48 21.5-48 48l0 48c0 14.2 6.2 27 16 35.8zM64 288l0-48 256 0 0 48-256 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBoxesPacking = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;